import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_RECORD_DATA, GET_RECORD_DATA_SUCCESS, GET_RECORD_DATA_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getRecordData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-records-data`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_RECORD_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RECORD_DATA_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RECORD_DATA_ERROR, payload: error });
  }
}

export function* watchGetRecordData() {
  yield takeEvery(GET_RECORD_DATA, getRecordData);
}

function* getRecordDataSaga() {
  yield all([fork(watchGetRecordData)]);
}

export default getRecordDataSaga;
